/**
 * 跨 feature 的编译时常量。
 * 仅放真正跨 feature 的；feature 私有常量放在 features/<name>/constants.ts。
 */

export const BROADCAST_CHANNELS = {
  AUTH: "eiam-admin:auth",
  PREFS: "eiam-admin:prefs",
} as const;

export const STORAGE_KEYS = {
  PREFERENCES: "eiam-admin:preferences",
  UI: "eiam-admin:ui",
  RECENT: "eiam-admin:recent",
  FAVORITES: "eiam-admin:favorites",
} as const;
